function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { requestChangePasswordLink } from "@common/actions";
import { validateEmail } from "@common/services/helpers";
import { STATUS_CODE_SUCCESS } from "@config/constants";
import PostForgottenPasswordRequest from "./PostForgottenPasswordRequest";
export var ForgottenPasswordRequest = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ForgottenPasswordRequest, PureComponent);
    var _super = _create_super(ForgottenPasswordRequest);
    function ForgottenPasswordRequest(props) {
        _class_call_check(this, ForgottenPasswordRequest);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            email: "",
            emailError: "",
            emailTouched: false,
            serverError: "",
            requestSuccess: false
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.requestChangePasswordLink = _this.requestChangePasswordLink.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ForgottenPasswordRequest, [
        {
            /**
     * Renders the navigation links.
     * @returns {*}
     */ key: "renderNavigation",
            value: function renderNavigation() {
                var i18n = this.props.i18n;
                var _i18n_authentication = i18n.authentication, forgottenPassword = _i18n_authentication.forgottenPassword, signIn = _i18n_authentication.signIn;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "secondary-navigation margin-bottom-med",
                    children: [
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/forgotten-password",
                            activeClassName: "selected",
                            className: "to-forgotten-password",
                            children: forgottenPassword
                        }),
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/login",
                            activeClassName: "selected",
                            className: "to-login",
                            children: signIn
                        })
                    ]
                });
            }
        },
        {
            /**
     * Sets the new state for the input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var newValue = event.target.value;
                this.setState({
                    email: newValue
                });
            }
        },
        {
            /**
     * Render the input.
     * @returns {*}
     */ key: "renderInput",
            value: function renderInput() {
                var _this = this;
                var _this_state = this.state, email = _this_state.email, emailError = _this_state.emailError, serverError = _this_state.serverError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(TextField, {
                        className: "ux-text-field-root",
                        autoComplete: "off",
                        InputProps: {
                            onBlur: function() {
                                return _this.setState({
                                    emailTouched: true
                                });
                            },
                            className: "ux-input",
                            classes: {
                                error: "ux-input-error"
                            }
                        },
                        InputLabelProps: {
                            classes: {
                                root: "ux-input-label"
                            }
                        },
                        FormHelperTextProps: {
                            error: true,
                            classes: {
                                root: "ux-form-helper-text"
                            }
                        },
                        error: emailError !== "" || serverError !== "",
                        helperText: serverError || emailError,
                        id: "email",
                        type: "text",
                        name: "email",
                        value: email,
                        label: i18n.authentication.email,
                        onChange: this.onChange,
                        margin: "none"
                    })
                });
            }
        },
        {
            key: "requestChangePasswordLink",
            value: /**
     * Request the backend to send to the provided
     * email address a mail with a link to the page in
     * the app from which he/she an enter the new password.
     * @param {Object} event
     */ function requestChangePasswordLink(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, email, emailError, emailTouched, errors, response, error, hasSpecificServerError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                _this_state = _this.state, email = _this_state.email, emailError = _this_state.emailError, emailTouched = _this_state.emailTouched;
                                errors = _this.props.i18n.errors;
                                if (emailError || !emailTouched && !validateEmail(email, null)) {
                                    return [
                                        2,
                                        validateEmail(email, function(isValid) {
                                            var emailError = isValid ? "" : _this.props.i18n.authentication.enterValidMail;
                                            _this.setState({
                                                emailError: emailError,
                                                serverError: ""
                                            });
                                        })
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.props.requestChangePasswordLink(email)
                                ];
                            case 2:
                                response = _state.sent();
                                if (response.status === STATUS_CODE_SUCCESS) {
                                    _this.setState({
                                        requestSuccess: true
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    _this.setState({
                                        emailTouched: true,
                                        serverError: errors["error".concat(error.subcode)]
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var requestSuccess = this.state.requestSuccess;
                var i18n = this.props.i18n;
                var contentTemplate = null;
                if (requestSuccess) {
                    contentTemplate = /*#__PURE__*/ _jsx(PostForgottenPasswordRequest, {
                        i18n: i18n
                    });
                } else {
                    contentTemplate = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            this.renderNavigation(),
                            /*#__PURE__*/ _jsxs("form", {
                                onSubmit: this.requestChangePasswordLink,
                                children: [
                                    this.renderInput(),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "note margin-top-small",
                                        children: i18n.authentication.changePasswordLinkNotification
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        className: "button raised full-width margin-top-med",
                                        type: "submit",
                                        children: i18n.authentication.sendChangePasswordLink
                                    })
                                ]
                            })
                        ]
                    });
                }
                return /*#__PURE__*/ _jsx("div", {
                    className: "forgotten-password-request-component".concat(requestSuccess ? " success" : ""),
                    children: contentTemplate
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this = this;
                var emailHasChangedOrEmpty = prevState.email !== this.state.email || this.state.email === "";
                var emailWasTouched = !prevState.emailTouched && this.state.emailTouched;
                var noServerError = this.state.serverError === "";
                if (emailHasChangedOrEmpty && this.state.emailTouched || emailWasTouched && noServerError) {
                    validateEmail(this.state.email, function(isValid) {
                        var emailError = isValid ? "" : _this.props.i18n.authentication.enterValidMail;
                        _this.setState({
                            emailError: emailError,
                            serverError: ""
                        });
                    });
                }
            }
        }
    ]);
    return ForgottenPasswordRequest;
}(PureComponent);
export default connect(null, {
    requestChangePasswordLink: requestChangePasswordLink
})(ForgottenPasswordRequest);
